import { createSlice } from "@reduxjs/toolkit";
import {getPlugin,getGoogleAnalytics,getGooglePixel,getAnalyticsDashboard,addWhatsAppPlugin,addTwilioPlugin,addTwoFactorPlugin,getWhatsAppPlugin, GetGooglePlugIn,} from "./ThunkAction";
import { iPluginState, REDUCER_NAME } from "./Types";

const initialState: iPluginState = {
  isLoading: false,
  pluginList: [],
  // @ts-expect-error
  whatsAppDtata:[],
  googleAnalyticsData: null,
  googlePixelData: null,
  analyticsDashboardData: null,
  errorMessage: null,
  googlePluginData: null,
};

export const PluginSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetPluginState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      // ✅ getPlugin
      .addCase(getPlugin.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPlugin.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.pluginList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getPlugin.rejected, (state) => {
        state.errorMessage = "Failed to fetch plugin data";
        state.isLoading = false;
      })

      // ✅ getGoogleAnalytics
     .addCase(getGoogleAnalytics.pending, (state) => {
  state.isLoading = true;
  state.errorMessage = null;
})

.addCase(getGoogleAnalytics.fulfilled, (state, action) => {
  // payload is directly the config object now
  state.googleAnalyticsData = action.payload;
  state.isLoading = false;
})

.addCase(getGoogleAnalytics.rejected, (state, action) => {
  state.errorMessage = action.payload?.message || "Failed to fetch Google Analytics data";
  state.isLoading = false;
})

      // ✅ getGooglePixel
      .addCase(getGooglePixel.pending, (state) => {
        state.isLoading = true;
      })
     .addCase(getGooglePixel.fulfilled, (state, action) => {
  state.googlePixelData = action.payload; // clean data
  state.isLoading = false;
})
      .addCase(getGooglePixel.rejected, (state) => {
        state.errorMessage = "Failed to fetch Google Pixel data";
        state.isLoading = false;
      })

      // ✅ getAnalyticsDashboard
      .addCase(getAnalyticsDashboard.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAnalyticsDashboard.fulfilled, (state, action) => {
        state.analyticsDashboardData = action.payload;
        state.isLoading = false;
      })
      .addCase(getAnalyticsDashboard.rejected, (state) => {
        state.errorMessage = "Failed to fetch Analytics dashboard data";
        state.isLoading = false;
      })

      // ✅ addWhatsAppPlugin
      .addCase(addWhatsAppPlugin.pending, (state) => {
        state.isLoading = true;
      })
     .addCase(addWhatsAppPlugin.fulfilled, (state) => {
  state.isLoading = false;
})
      .addCase(addWhatsAppPlugin.rejected, (state, action) => {
        // @ts-expect-error
        state.errorMessage = action.payload?.message || "Failed to add WhatsApp plugin";
        state.isLoading = false;
      })

      // ✅ addTwilioPlugin
.addCase(addTwilioPlugin.pending, (state) => {
  state.isLoading = true;
})
.addCase(addTwilioPlugin.fulfilled, (state, action) => {
  const payload = action.payload;
  if (payload && payload.data) {
    // Optionally update pluginList (push or trigger re-fetch)
    state.pluginList.push(payload.data); // adjust if payload.data.data
    state.isLoading = false;
  }
})
.addCase(addTwilioPlugin.rejected, (state, action) => {
// @ts-expect-error
  state.errorMessage = action.payload?.message || "Failed to add Twilio plugin";
  state.isLoading = false;
})
// ✅ getWhatsAppPlugin
.addCase(getWhatsAppPlugin.pending, (state) => {
  state.isLoading = true;
})
.addCase(getWhatsAppPlugin.fulfilled, (state, action) => {
  if (action.payload) {
    // @ts-expect-error
    state.whatsAppDtata = [action.payload]; 
  }
  state.isLoading = false;
})
.addCase(getWhatsAppPlugin.rejected, (state, action) => {
  const fallbackMessage =
    typeof action.payload === "object" && action.payload && "message" in action.payload
      ? (action.payload as { message: string }).message
      : "Failed to fetch WhatsApp plugin data";
  state.errorMessage = fallbackMessage;
  state.isLoading = false;
})

// addTwoFactorPlugin
      .addCase(addTwoFactorPlugin.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addTwoFactorPlugin.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.pluginList.push(payload.data);
        }
        state.isLoading = false;
      })
      .addCase(addTwoFactorPlugin.rejected, (state, action) => {
        const fallbackMessage =
          typeof action.payload === "object" && action.payload && "message" in action.payload
            ? (action.payload as { message: string }).message
            : "Failed to add Two-Factor plugin";
        state.errorMessage = fallbackMessage;
        state.isLoading = false;
      })


      .addCase(GetGooglePlugIn.pending, (state) => {
  state.isLoading = true;
})

.addCase(GetGooglePlugIn.fulfilled, (state, action) => {
  if (action.payload?.data) {
    state.googlePluginData = action.payload.data; // ✅ clean data
  }
  state.isLoading = false;
})

.addCase(GetGooglePlugIn.rejected, (state, action) => {
  state.errorMessage =
  // @ts-expect-error
    action.payload?.message || "Failed to fetch Google Plugin";
  state.isLoading = false;
})


  }
  

});

export const { resetPluginState } = PluginSlice.actions;
export default PluginSlice.reducer;
